import { useAuth } from './useAuth';

/** Agency staff roles that may govern the agency (mirrors backend `requireAgencyOwnerOrAdmin`). */
export const canManageAgencyGovernanceRole = (
  agencyRole: 'OWNER' | 'ADMIN' | 'MANAGER' | 'MEMBER' | null | undefined
): boolean => agencyRole === 'OWNER' || agencyRole === 'ADMIN';

/**
 * Single source of truth for agency governance rights, from the agency staff role in /me.
 * OWNER / ADMIN only: create or delete a brand, write agency name/email, remove team members,
 * toggle the reviewer flag, invite admins, edit brand assignments of oneself (managers cannot).
 * MANAGER / MEMBER keep day-to-day work but not these.
 */
export const useAgencyGovernance = (): {
  canManageAgencyGovernance: boolean;
  agencyRole: 'OWNER' | 'ADMIN' | 'MANAGER' | 'MEMBER' | null;
} => {
  const { user } = useAuth();
  const agencyRole = user?.agencyRole ?? null;
  return { canManageAgencyGovernance: canManageAgencyGovernanceRole(agencyRole), agencyRole };
};
